var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6436 7.8903L13.4427 12.2738L17.6436 16.6573C18.1057 17.1395 18.1057 17.9285 17.6436 18.4107C17.1815 18.8929 16.4253 18.8929 15.9632 18.4107L11.7624 14.0272L7.56154 18.4107C7.09944 18.8929 6.34329 18.8929 5.8812 18.4107C5.4191 17.9285 5.4191 17.1395 5.8812 16.6573L10.082 12.2738L5.8812 7.8903C5.4191 7.40811 5.4191 6.61908 5.8812 6.1369C6.34329 5.65471 7.09944 5.65471 7.56154 6.1369L11.7624 10.5204L15.9632 6.1369C16.4253 5.65471 17.1815 5.65471 17.6436 6.1369C18.1057 6.61908 18.1057 7.40811 17.6436 7.8903Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "transparent"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/Close.icon.6a55d2b127a0e1cffc420736437843c0.svg";
export { ForwardRef as ReactComponent };